<template>
  <custom-dialog class="select-user-dialog" width="700px" :title="model.title" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body">
      <div class="waitdevice-right ub">
        <div class="left-box ub-f1">
          <div class="tit">{{ $t('base_select_user_dialog.xuan_ze_bu_men') }}</div>
          <div class="tree-box">
            <div class="tree">
              <el-tree
                ref="tree"
                show-checkbox
                node-key="bizId"
                :data="organTree"
                :props="{ label: 'bizName' }"
                @check-change="checkChange"
                :expand-on-click-node="false"
                :default-expanded-keys="expandedKeys"
                :default-checked-keys="checkedKeys"
                highlight-current
              >
                <span class="tree-item" slot-scope="{ node, data }">
                  <i style="color: #F7B500" v-if="data.bizType === 3" class="icon icon-yonghu1"></i>
                  <i style="color: #00AFFF" v-else class="icon icon-zuzhi1"></i>
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
        <div class="right-box ub-f1">
          <div class="tit">{{ $t('base_select_user_dialog.yi_xuan_bu_men') }}</div>
          <div class="tree-box">
            <div class="tree">
              <el-tree
                ref="tree1"
                check-strictly
                node-key="bizId"
                :data="organTree"
                :props="{ label: 'bizName' }"
                :expand-on-click-node="false"
                :default-expanded-keys="expandedKeys"
                :filter-node-method="filterCheckNode"
                highlight-current
              >
                <span class="tree-item" slot-scope="{ node, data }">
                  <i style="color: #F7B500" v-if="data.bizType === 3" class="icon icon-yonghu1"></i>
                  <i style="color: #00AFFF" v-else class="icon icon-zuzhi1"></i>
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      expandedKeys: [],
      checkedKeys: [],
      organTree: [],
      treeProps: {
        children: 'children',
        label: 'bizName'
      },
      selectNodes: []
    };
  },
  computed: {
    // 用户节点
    userNodes() {
      return this.selectNodes.filter(item => item.bizType === 3);
    }
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.$emit('confirm', this.userNodes);
      this.closeDialog();
    },
    // 获取组织
    getOrganTree: function () {
      return this.$getJSON(apis.DepartmentTree, { isShowUsers: 1 }).then((res) => {
        this.expandedKeys = [res.data.bizId];
        this.organTree = [res.data];
        this.$nextTick(() => {
          this.$refs.tree1.filter([]);
          this.checkChange();
        });
      });
    },
    // 选中转换树
    checkChange: function () {
      this.selectNodes = this.$refs.tree.getCheckedNodes(false, true);
      this.$refs.tree1.filter(this.selectNodes);
    },
    // 选中树过滤
    filterCheckNode(nodes, data) {
      return !!nodes.find(t => t.bizId === data.bizId);
    }
  },
  mounted() {
    this.checkedKeys = [...this.model.data.selectedNodeIds];
    this.getOrganTree();
  }
};
</script>

<style></style>
